import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  message,
  PageHeader,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Upload,
} from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";

import * as XLSX from "xlsx-js-style";
import { professionalAction } from "../../_actions";
import { cctnsService } from "../../_services/cctns.service";
import { ImageViewOnly } from "../image/onlyImageVIew";
import {
  BarChartOutlined,
  FileTextOutlined,
  PlusOutlined,
  UnorderedListOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { authHeader } from "../../_helpers";
import { Link } from "react-router-dom";
const { Option } = Select;
const CCTNS_MISSING_IMAGE_URL =
  "https://cctns-missing-persons.s3.ap-south-1.amazonaws.com/";

class CcntsMissingReport extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
    this.updateFormRef = React.createRef();
    this.addFormRef = React.createRef();
  }
  state = {
    report_4_startDate: moment().format("YYYY-MM-DD"),
    report_4_endDate: moment().format("YYYY-MM-DD"),
    appliedStartDate: moment().format("YYYY-MM-DD"),
    appliedEndDate: moment().format("YYYY-MM-DD"),
    activeRange: "daily",
    order_by: "",
    direction: "ASC",
    download: "excel",
    data: [],
    loading: false,
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
    showList: "list",
    showCountModal: false,
    countDetails: [],
    countDetailsLoading: false,
    selectedDistrict: null,
    modalPagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
    modal_order_by: "",
    modal_direction: "ASC",
    showUpdateModal: false,
    selectedMissing: null,
    updateLoading: false,
    originalFileList: [],
    originalImageName: null,
    districtName: "",
    showAddModal: false,
    addLoading: false,
    addOriginalFileList: [],
    addOriginalImageName: null,
  };
  onChangeType = (value) => {
    this.setState({
      type: value,
    });
  };

  isDateFilterRole = () => {
    const role = this.props.user?.role;
    return role === "4" || role === "2" || role === "9" || role === "10";
  };

  isOperatorRole = () => {
    const role = this.props.user?.role;
    return role === "9" || role === "10";
  };

  isStatisticsRole = () => {
    const role = this.props.user?.role;
    return role === "4" || role === "9" || role === "10";
  };

  getMappedDistrictIds = (raw = this.props.user?.map_districtId) => {
    if (Array.isArray(raw)) {
      return raw.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    }
    if (raw === null || raw === undefined || raw === "" || raw === false) {
      return [];
    }
    if (typeof raw === "string") {
      const trimmed = raw.trim();
      if (trimmed.startsWith("[")) {
        try {
          return this.getMappedDistrictIds(JSON.parse(trimmed));
        } catch (e) {
          /* fall through */
        }
      }
      return trimmed
        .replace(/[\[\]]/g, "")
        .split(",")
        .map((id) => Number(String(id).trim()))
        .filter((id) => Number.isFinite(id));
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? [parsed] : [];
  };

  getDateSortParams = (view = this.state.showList) => {
    const { appliedStartDate, appliedEndDate, order_by, direction } =
      this.state;
    const params = {};
    if (this.isDateFilterRole() && appliedStartDate && appliedEndDate) {
      params.startDate = moment(appliedStartDate).format("YYYY-MM-DD");
      params.endDate = moment(appliedEndDate).format("YYYY-MM-DD");
    }
    const validSortFields =
      view === "count"
        ? ["district_name", "missing_count"]
        : ["date", "name", "age", "police_station"];
    if (this.isDateFilterRole() && validSortFields.includes(order_by)) {
      params.order_by = order_by;
      params.direction = direction || "ASC";
    }
    return params;
  };

  reloadCurrentView = () => {
    if (this.state.showList === "count") {
      this.cctnsMissingRoleWiseCount();
    } else {
      this.cctnsMissingRoleWiseList();
    }
  };

  onStartDateChange = (date) => {
    if (date) {
      this.setState({
        report_4_startDate: date.toISOString(),
        report_4_endDate: null,
        activeRange: "",
      });
    } else {
      this.setState({
        report_4_startDate: "",
        report_4_endDate: "",
        activeRange: "",
      });
    }
  };

  onEndDateChange = (date) => {
    this.setState({
      report_4_endDate: date ? date.toISOString() : "",
      activeRange: "",
    });
  };

  setQuickRange = (type) => {
    let startDate = null;
    let endDate = moment();

    switch (type) {
      case "daily":
        startDate = moment();
        break;
      case "month":
        startDate = moment().startOf("month");
        break;
      case "6month":
        startDate = moment().subtract(6, "months");
        break;
      case "year":
        startDate = moment().subtract(1, "year");
        break;
      default:
        return;
    }

    this.setState({
      report_4_startDate: startDate.format("YYYY-MM-DD"),
      report_4_endDate: endDate.format("YYYY-MM-DD"),
      activeRange: type,
    });
  };

  applyDateFilter = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    if (!report_4_startDate || !report_4_endDate) {
      return;
    }
    this.setState(
      {
        appliedStartDate: report_4_startDate,
        appliedEndDate: report_4_endDate,
        pagination: {
          ...this.state.pagination,
          current: 1,
        },
      },
      this.reloadCurrentView,
    );
  };

  clearDateFilter = () => {
    const today = moment().format("YYYY-MM-DD");
    this.setState(
      {
        report_4_startDate: today,
        report_4_endDate: today,
        appliedStartDate: today,
        appliedEndDate: today,
        activeRange: "daily",
        order_by: "",
        direction: "ASC",
        pagination: {
          ...this.state.pagination,
          current: 1,
        },
      },
      this.reloadCurrentView,
    );
  };

  getDistrictName = (id) => {
    professionalAction.getDistrictsid(id).then((res) => {
      const tempData = res.pc_districts;
      const districtName = tempData?.[0]?.DistrictName || "";

      console.log("District Name:", districtName);

      this.setState({
        districtName,
      });
    });
  };

  cctnsMissingRoleWiseCount = () => {
    this.setState({
      loading: true,
    });
    const { user } = this.props;
    const temp = {
      cityId: user.cityId,
      label: "city",
      ...this.getDateSortParams("count"),
    };
    if (this.isOperatorRole()) {
      temp.districtId = this.getMappedDistrictIds();
    }
    cctnsService.cctnsMissingRoleWiseCount(temp).then((res) => {
      console.log("RES", res);
      this.setState({
        data: res.data,
        loading: false,
      });
    });
  };

  cctnsMissingRoleWiseList = () => {
    this.setState({
      loading: true,
    });
    const { user } = this.props;
    let temp;
    if (user.role === "4") {
      temp = {
        cityId: user.cityId,
        label: "city",
        ...this.getDateSortParams("list"),
      };
    } else if (this.isOperatorRole()) {
      temp = {
        cityId: user.cityId,
        label: "city",
        districtId: this.getMappedDistrictIds(),
        ...this.getDateSortParams("list"),
      };
    } else {
      temp = {
        cityId: user.cityId,
        label: "city",
        districtId: user.role === "2" ? [user.districtId] : user.map_districtId,
        ...this.getDateSortParams("list"),
      };
    }
    cctnsService.cctnsMissingRoleWiseList(temp).then((res) => {
      console.log("RES", res);
      this.setState({
        data: res.data,
        loading: false,
      });
    });
  };

  compareText = (a, b) =>
    String(a || "").localeCompare(String(b || ""), undefined, {
      numeric: true,
      sensitivity: "base",
    });

  compareNumber = (a, b) => Number(a || 0) - Number(b || 0);

  compareDate = (a, b) => {
    const start = a && moment(a).isValid() ? moment(a).valueOf() : 0;
    const end = b && moment(b).isValid() ? moment(b).valueOf() : 0;
    return start - end;
  };

  getPoliceStationValue = (record) =>
    record?.police_station
      ? `${record.police_station} - ${record.district || ""}`
      : record?.district || "";

  getTableSortOrder = (field, sortState = {}) => {
    const orderBy =
      sortState.order_by !== undefined
        ? sortState.order_by
        : this.state.order_by;
    const direction =
      sortState.direction !== undefined
        ? sortState.direction
        : this.state.direction;
    if (orderBy !== field) {
      return undefined;
    }
    return direction === "DESC" ? "descend" : "ascend";
  };

  getSortedRows = (rows, view, order_by, direction) => {
    if (!rows || !rows.length || !order_by) {
      return rows || [];
    }
    const sorted = [...rows].sort((a, b) => {
      let result = 0;
      if (view === "count") {
        if (order_by === "district_name") {
          result = this.compareText(a.district_name, b.district_name);
        } else if (order_by === "missing_count") {
          result = this.compareNumber(a.missing_count, b.missing_count);
        }
      } else if (order_by === "date") {
        result = this.compareDate(a.date, b.date);
      } else if (order_by === "name") {
        result = this.compareText(a.name, b.name);
      } else if (order_by === "police_station") {
        result = this.compareText(
          this.getPoliceStationValue(a),
          this.getPoliceStationValue(b),
        );
      } else if (order_by === "incident_place") {
        result = this.compareText(a.incident_place, b.incident_place);
      } else if (order_by === "age") {
        result = this.compareNumber(a.age, b.age);
      }
      return direction === "DESC" ? -result : result;
    });
    return sorted;
  };

  getOrderByFromColumn = (sorter) => {
    const sorterInfo = Array.isArray(sorter) ? sorter[0] : sorter;
    const columnKeyToOrderBy = {
      date_of_missing: "date",
      name: "name",
      district: "police_station",
      incident_place: "incident_place",
      age: "age",
      district_name: "district_name",
      missing_count: "missing_count",
    };
    if (!sorterInfo || (!sorterInfo.columnKey && !sorterInfo.field)) {
      return null;
    }
    if (!sorterInfo.order) {
      return { order_by: "", direction: "ASC" };
    }
    return {
      order_by:
        columnKeyToOrderBy[sorterInfo.columnKey] ||
        columnKeyToOrderBy[sorterInfo.field] ||
        "",
      direction: sorterInfo.order === "descend" ? "DESC" : "ASC",
    };
  };

  handleTableChange = (pagination, filters, sorter) => {
    const sortState = this.getOrderByFromColumn(sorter);
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination,
      },
      ...(sortState || {}),
    });
  };

  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  componentDidMount = () => {
    this.props.dispatch(professionalAction.getCity());
    const { user } = this.props;

    this.cctnsMissingRoleWiseList();
    if (user.role !== "4" && user.districtId) {
      this.getDistrictName(user.districtId);
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  openImageModal = (img, name) => {
    this.setState({
      imageOpen: true,
      selectedImage: img,
      name: name || null,
    });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };

  openCountDetailsModal = (record) => {
    if (!record || Number(record.missing_count || 0) === 0) {
      return;
    }

    const { user } = this.props;
    this.setState({
      showCountModal: true,
      countDetails: [],
      countDetailsLoading: true,
      selectedDistrict: record,
      modal_order_by: "",
      modal_direction: "ASC",
      modalPagination: {
        ...this.state.modalPagination,
        current: 1,
      },
    });

    cctnsService
      .cctnsMissingRoleWiseList({
        cityId: user.cityId,
        label: "city",
        districtId: record.district_id ? [record.district_id] : [],
        ...this.getDateSortParams("list"),
      })
      .then((res) => {
        this.setState({
          countDetails: res.data || [],
          countDetailsLoading: false,
        });
      })
      .catch((err) => {
        console.error("Error fetching missing list:", err);
        this.setState({
          countDetails: [],
          countDetailsLoading: false,
        });
      });
  };

  closeCountDetailsModal = () => {
    this.setState({
      showCountModal: false,
      countDetails: [],
      selectedDistrict: null,
      countDetailsLoading: false,
      modal_order_by: "",
      modal_direction: "ASC",
    });
  };

  handleModalTableChange = (pagination, filters, sorter) => {
    const sortState = this.getOrderByFromColumn(sorter);
    this.setState({
      modalPagination: {
        ...this.state.modalPagination,
        ...pagination,
      },
      ...(sortState
        ? {
            modal_order_by: sortState.order_by,
            modal_direction: sortState.direction,
          }
        : {}),
    });
  };

  isMissingFound = (value) =>
    value === true || value === 1 || value === "1" || value === "found";

  openUpdateModal = (record) => {
    const existingFile = record?.original_file;
    this.setState({
      showUpdateModal: true,
      selectedMissing: record,
      updateLoading: false,
      originalImageName: existingFile || null,
      originalFileList: existingFile
        ? [
            {
              uid: existingFile,
              name: existingFile,
              status: "done",
              url: CCTNS_MISSING_IMAGE_URL + existingFile,
            },
          ]
        : [],
    });
  };

  closeUpdateModal = () => {
    this.updateFormRef.current?.resetFields();
    this.setState({
      showUpdateModal: false,
      selectedMissing: null,
      updateLoading: false,
      originalFileList: [],
      originalImageName: null,
    });
  };

  handleOriginalFileChange = ({ fileList }) => {
    if (!fileList.length) {
      this.setState({
        originalFileList: [],
        originalImageName: null,
      });
      return;
    }
    this.setState({
      originalFileList: fileList.slice(-1),
    });
  };

  beforeOriginalFileUpload = (file) => {
    const isImage = /jpeg|jpg|png|gif/.test(file.type);
    if (!isImage) {
      message.error("Please upload only image file!");
      return Upload.LIST_IGNORE;
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("Image size larger than 10MB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  uploadOriginalImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const baseUrl = `${process.env.REACT_APP_URL}/api`;
    const fmData = new FormData();
    const safeName = String(file.name || "photo")
      .trim()
      .replace(/\s+/g, "");
    const newFileName = safeName.toLowerCase().startsWith("mi_")
      ? safeName
      : `Mi_${safeName}`;
    fmData.append("cctns-missing-persons", file, newFileName);

    axios
      .post(`${baseUrl}/imageupload/cctns-missing-image-upload`, fmData, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          ...authHeader(),
        },
        onUploadProgress: (event) => {
          const percent = Math.floor((event.loaded / event.total) * 100);
          onProgress({ percent: percent || 0 });
        },
      })
      .then((res) => {
        if (res.data && res.data.error) {
          onError({ ...res.data.error });
          message.error("Image upload failed");
        } else {
          const imageName = res.data.imageName;
          this.setState({
            originalImageName: imageName,
            originalFileList: [
              {
                uid: imageName || `${Date.now()}`,
                name: imageName,
                status: "done",
                url: CCTNS_MISSING_IMAGE_URL + imageName,
              },
            ],
          });
          onSuccess("Ok");
        }
      })
      .catch((err) => {
        console.error("cctns original image upload error", err);
        message.error("Image upload failed");
        onError({ err });
      });
  };

  submitMissingUpdate = () => {
    const { t } = this.context;
    const { user } = this.props;
    const { selectedMissing } = this.state;
    const form = this.updateFormRef.current;

    if (!form || !selectedMissing?.id) {
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const isFound = values.is_found === "found";
        if (isFound && !values.foundDate) {
          message.warning(t("select_date"));
          return;
        }

        this.setState({ updateLoading: true });
        cctnsService
          .updateCctnsMissing({
            id: selectedMissing.id,
            io_name: values.io_name,
            io_number: values.io_number,
            is_found: isFound ? 1 : 0,
            foundDate:
              isFound && values.foundDate
                ? moment(values.foundDate).format("YYYY-MM-DD")
                : null,
            userid: user.id,
            cityId: user.cityId,
            original_file: this.state.originalImageName || null,
            districtId:
              this.props.user.role === "2" && this.props.user.districtId,
          })
          .then(() => {
            message.success(t("update"));
            this.closeUpdateModal();
            if (this.state.showList === "list") {
              this.cctnsMissingRoleWiseList();
            }
            if (this.state.showList === "count") {
              this.cctnsMissingRoleWiseCount();
            }
            if (this.state.showCountModal && this.state.selectedDistrict) {
              this.openCountDetailsModal(this.state.selectedDistrict);
            }
          })
          .catch((err) => {
            console.error("updateCctnsMissing error", err);
            message.error(err?.message || t("update"));
            this.setState({ updateLoading: false });
          });
      })
      .catch(() => {});
  };

  openAddModal = () => {
    this.setState({
      showAddModal: true,
      addLoading: false,
      addOriginalFileList: [],
      addOriginalImageName: null,
    });
  };

  closeAddModal = () => {
    this.addFormRef.current?.resetFields();
    this.setState({
      showAddModal: false,
      addLoading: false,
      addOriginalFileList: [],
      addOriginalImageName: null,
    });
  };

  uploadAddImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const baseUrl = `${process.env.REACT_APP_URL}/api`;
    const fmData = new FormData();
    const safeName = String(file.name || "photo")
      .trim()
      .replace(/\s+/g, "");
    const newFileName = safeName.toLowerCase().startsWith("mi_")
      ? safeName
      : `Mi_${safeName}`;
    fmData.append("cctns-missing-persons", file, newFileName);

    axios
      .post(`${baseUrl}/imageupload/cctns-missing-image-upload`, fmData, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          ...authHeader(),
        },
        onUploadProgress: (event) => {
          const percent = Math.floor((event.loaded / event.total) * 100);
          onProgress({ percent: percent || 0 });
        },
      })
      .then((res) => {
        if (res.data && res.data.error) {
          onError({ ...res.data.error });
          message.error("Image upload failed");
        } else {
          const imageName = res.data.imageName;
          this.setState(
            {
              addOriginalImageName: imageName,
              addOriginalFileList: [
                {
                  uid: imageName || `${Date.now()}`,
                  name: imageName,
                  status: "done",
                  url: CCTNS_MISSING_IMAGE_URL + imageName,
                },
              ],
            },
            () => {
              this.addFormRef.current?.setFieldsValue({
                original_file: imageName,
              });
              onSuccess("Ok");
            },
          );
        }
      })
      .catch((err) => {
        console.error("cctns add image upload error", err);
        message.error("Image upload failed");
        onError({ err });
      });
  };

  submitMissingAdd = () => {
    const { t } = this.context;
    const { user } = this.props;
    const form = this.addFormRef.current;

    if (!form) {
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const isFound = values.is_found === "found";
        if (isFound && !values.foundDate) {
          message.warning(t("select_date"));
          return;
        }
        if (!this.state.addOriginalImageName) {
          message.warning(t("original_file"));
          return;
        }

        this.setState({ addLoading: true });
        cctnsService
          .addCctnsMissing({
            name: values.name,
            date: moment(values.date).format("YYYY-MM-DD"),
            age: values.age || null,
            gender: values.gender || null,
            incident_place: values.incident_place || null,
            io_name: values.io_name || null,
            io_number: values.io_number || null,
            is_found: isFound ? 1 : 0,
            foundDate:
              isFound && values.foundDate
                ? moment(values.foundDate).format("YYYY-MM-DD")
                : null,
            userid: user.id,
            cityId: user.cityId,
            districtId: user.districtId,
            original_file: this.state.addOriginalImageName || null,
          })
          .then(() => {
            message.success(t("add_new"));
            this.closeAddModal();
            this.cctnsMissingRoleWiseList();
          })
          .catch((err) => {
            console.error("addCctnsMissing error", err);
            const text = typeof err === "string" ? err : err?.message;
            message.error(text || t("add_new"));
            this.setState({ addLoading: false });
          });
      })
      .catch(() => {});
  };

  downloadReport = (source = "page") => {
    this.download_csv(source);
  };

  download_csv = (source = "page") => {
    const { t } = this.context;
    const { showList, data, countDetails, selectedDistrict } = this.state;
    const isModal = source === "modal";
    const isList = isModal || showList === "list";
    const rows = this.getSortedRows(
      isModal ? countDetails : data,
      isModal ? "list" : showList,
      isModal ? this.state.modal_order_by : this.state.order_by,
      isModal ? this.state.modal_direction : this.state.direction,
    );

    if (!rows || !rows.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const ReportTitle = isModal
      ? `${t(t("cctns_missing"))} ${t("list")}${
          selectedDistrict?.district_name
            ? ` - ${selectedDistrict.district_name}`
            : ""
        }`
      : `${t("cctns_missing")} ${isList ? t("list") : t("statistics")}`;
    const file_name = `${ReportTitle.replace(/[\\/:*?"<>|]/g, "_").replace(
      /\s+/g,
      "_",
    )}_${moment().format("DDMMMYYYY")}`;

    const arrData = isList
      ? rows.map((item, index) => ({
          [t("sr.no")]: index + 1,
          [t("date_of_missing")]: moment(item.date).format("DD-MM-YYYY"),
          [t("missing_people")]: item?.name || "-",
          [t("accused_police_station")]: item?.police_station
            ? `${item.police_station} - ${item.district || "-"}`
            : item?.district || "-",
          [t("incident_place")]: item?.incident_place || "-",
          [t("age")]: item?.age || "-",
          [t("photo")]: item?.photo ? t("yes") : t("no"),
        }))
      : rows.map((item, index) => ({
          [t("sr.no")]: index + 1,
          [t("police_stations")]: item?.district_name || "-",
          [t("total")]: Number(item?.missing_count || 0),
        }));

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;
    const cityName = this.getCityName(this.props?.user?.cityId || "") || "";
    const headerData =
      this.props.user.role === "4" || this.isOperatorRole()
        ? cityName
        : `${this.state.districtName} (${cityName})`;

    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });
    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", wrapText: true },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];
    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  getShowList = (type) => {
    this.setState(
      {
        showList: type,
        order_by: "",
        direction: "ASC",
        pagination: {
          ...this.state.pagination,
          current: 1,
        },
      },
      () => {
        if (type === "count") {
          this.cctnsMissingRoleWiseCount();
        }
        if (type === "list") {
          this.cctnsMissingRoleWiseList();
        }
      },
    );
  };
  render() {
    const { user } = this.props;
    console.log("user", user);
    const {
      showList,
      data,
      pagination,
      loading,
      showCountModal,
      countDetails,
      countDetailsLoading,
      selectedDistrict,
      modalPagination,
      showUpdateModal,
      selectedMissing,
      updateLoading,
      originalFileList,
      showAddModal,
      addLoading,
      addOriginalFileList,
    } = this.state;
    const { t } = this.context;
    const isAlreadyFound =
      this.isMissingFound(selectedMissing?.is_found) &&
      !!selectedMissing?.foundDate;
    const getListColumns = (tablePagination, options = {}) => [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        width: 80,
        render: (_, __, rowIndex) =>
          (tablePagination.current - 1) * tablePagination.pageSize +
          rowIndex +
          1,
      },
      {
        title: t("date_of_missing"),
        dataIndex: "date_of_missing",
        key: "date_of_missing",
        width: 180,
        sorter: (a, b) => this.compareDate(a.date, b.date),
        ...(options.controlled
          ? { sortOrder: this.getTableSortOrder("date", options) }
          : {}),
        render: (text, record) => (
          <Space size="middle">
            {record?.date && moment(record.date).isValid()
              ? moment(record.date).format("DD-MM-YYYY")
              : "-"}
          </Space>
        ),
      },
      {
        title: t("missing_people"),
        dataIndex: "name",
        key: "name",
        width: 180,
        sorter: (a, b) =>
          this.compareText(
            a.name?.replace(/^-+\s*/, ""),
            b.name?.replace(/^-+\s*/, ""),
          ),
        ...(options.controlled
          ? { sortOrder: this.getTableSortOrder("name", options) }
          : {}),
        render: (text, record) => (
          <Space size="middle">{record?.name?.replace(/^-+\s*/, "")}</Space>
        ),
      },
      {
        title: t("accused_police_station"),
        dataIndex: "district",
        key: "district",
        width: 150,
        ellipsis: true,
        sorter: (a, b) =>
          this.compareText(
            this.getPoliceStationValue(a),
            this.getPoliceStationValue(b),
          ),
        ...(options.controlled
          ? { sortOrder: this.getTableSortOrder("police_station", options) }
          : {}),
        render: (text, record) => {
          const value = record.police_station
            ? `${record.police_station} - ${record.district}`
            : record.district;

          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
      {
        title: t("incident_place"),
        dataIndex: "incident_place",
        key: "incident_place",
        width: 180,
        sorter: (a, b) => this.compareText(a.incident_place, b.incident_place),
        ...(options.controlled
          ? { sortOrder: this.getTableSortOrder("incident_place", options) }
          : {}),
      },
      {
        title: t("age"),
        dataIndex: "age",
        key: "age",
        width: 80,
        sorter: (a, b) => this.compareNumber(a.age, b.age),
        ...(options.controlled
          ? { sortOrder: this.getTableSortOrder("age", options) }
          : {}),
      },
      {
        title: t("photo"),
        key: "Photo",
        width: 100,
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.photo ? (
              <img
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                src={CCTNS_MISSING_IMAGE_URL + record.photo}
                onClick={() => this.openImageModal(record.photo, record.name)}
                alt={record.name || "Photo"}
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
      {
        title: t("original_file1"),
        key: "original_file",
        width: 100,
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.original_file ? (
              <img
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                src={CCTNS_MISSING_IMAGE_URL + record.original_file}
                onClick={() => this.openImageModal(record.original_file, record.name)}
                alt={record.name || "Photo"}
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
      ...(this.props.user?.role === "4" || this.props.user?.role === "2"
        ? [
            {
              title: t("action"),
              key: "action",
              width: 120,
              fixed: "right",
              render: (text, record) => (
                <Button
                  type="link"
                  size="small"
                  className="action-link update-link"
                  onClick={() => this.openUpdateModal(record)}
                >
                  {t("update")}
                </Button>
              ),
            },
          ]
        : []),
    ];
    const columns =
      showList === "list"
        ? getListColumns(pagination, { controlled: true })
        : [
            {
              title: t("sr.no"),
              key: "srNo",
              width: 80,
              render: (_, __, rowIndex) =>
                (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
            },
            {
              title: "District",
              dataIndex: "district_name",
              key: "district_name",
              width: 180,
              sorter: (a, b) =>
                this.compareText(a.district_name, b.district_name),
              sortOrder: this.getTableSortOrder("district_name"),
            },
            {
              title: "Missing Count",
              dataIndex: "missing_count",
              key: "missing_count",
              width: 150,
              align: "center",
              sorter: (a, b) =>
                this.compareNumber(a.missing_count, b.missing_count),
              sortOrder: this.getTableSortOrder("missing_count"),
              render: (count, record) => (
                <Button
                  type="primary"
                  shape="circle"
                  size="small"
                  style={{
                    width: 36,
                    height: 36,
                    fontWeight: 600,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                  disabled={Number(count || 0) === 0}
                  onClick={() => this.openCountDetailsModal(record)}
                >
                  {Number(count || 0)}
                </Button>
              ),
            },
          ];
    return (
      <>
        <Spin spinning={this.state.loading} delay={500}>
          <div className="col-md-6 col-md-offset-3">
            <div className="site-page-header-ghost-wrapper">
              <PageHeader
                className="site-page-header"
                ghost={false}
                onBack={false}
                title={t("cctns_missing")}
                extra={[
                  <>
                    {this.props.user.role === "4" && (
                      <Link
                        className="admin-nd-ps-badge admin-nd-ps-badge--clickable"
                        to={"/cctns-districts-map"}
                      >
                        <FileTextOutlined />
                        <span type="primary">Map Police Station</span>
                      </Link>
                    )}
                    {this.props.user.role === "2" && (
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={this.openAddModal}
                      >
                        {t("add_new")}
                      </Button>
                    )}
                  </>,
                ]}
              />
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Count Button */}
                {this.isStatisticsRole() && (
                  <Button
                    type={showList === "count" ? "primary" : "default"}
                    onClick={() => this.getShowList("count")}
                    icon={<BarChartOutlined />}
                    style={{
                      minWidth: "120px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    {t("statistics")}
                  </Button>
                )}

                {/* List Button */}

                <Button
                  type={showList === "list" ? "primary" : "default"}
                  onClick={() => this.getShowList("list")}
                  icon={<UnorderedListOutlined />}
                  style={{
                    minWidth: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {t("list")}
                </Button>

                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 14px",
                    background: "#6f42c1",
                    borderRadius: 6,
                    boxShadow: "0 2px 6px rgba(111, 66, 193, 0.25)",
                  }}
                >
                  <span style={{ fontSize: 13, color: "#fff" }}>
                    {t("total")}:
                  </span>

                  <strong style={{ fontSize: 16, color: "#fff" }}>
                    {showList === "count"
                      ? data.reduce(
                          (total, item) =>
                            total + Number(item.missing_count || 0),
                          0,
                        )
                      : data.length}
                  </strong>
                </div>
                <Select
                  style={{ width: 120 }}
                  value={this.state.download}
                  onChange={(value) => this.setState({ download: value })}
                >
                  <Option value="excel">{t("excel")}</Option>
                </Select>
                <Button
                  type="primary"
                  disabled={!this.state.download || !data.length}
                  onClick={() => this.downloadReport()}
                >
                  {t("download")}
                </Button>
              </div>
              {this.isDateFilterRole() && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    padding: "12px",
                    background: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginBottom: "12px",
                  }}
                >
                  <span style={{ fontSize: "14px", fontWeight: 500 }}>
                    {t("select_date")}:
                  </span>
                  <Space>
                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "daily"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("daily")}
                    >
                      Daily
                    </Button>
                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "month"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("month")}
                    >
                      Month
                    </Button>
                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "6month"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("6month")}
                    >
                      6 Month
                    </Button>
                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "year"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("year")}
                    >
                      1 Year
                    </Button>
                  </Space>
                  <DatePicker
                    value={
                      this.state.report_4_startDate
                        ? moment(this.state.report_4_startDate)
                        : null
                    }
                    onChange={this.onStartDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format="DD/MM/YYYY"
                    inputReadOnly
                    style={{ minWidth: "150px" }}
                  />
                  <DatePicker
                    value={
                      this.state.report_4_endDate
                        ? moment(this.state.report_4_endDate)
                        : null
                    }
                    onChange={this.onEndDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format="DD/MM/YYYY"
                    inputReadOnly
                    style={{ minWidth: "150px" }}
                    disabled={!this.state.report_4_startDate}
                    disabledDate={(current) =>
                      current &&
                      this.state.report_4_startDate &&
                      current <
                        moment(this.state.report_4_startDate).startOf("day")
                    }
                  />
                  <Button
                    type="primary"
                    disabled={
                      !this.state.report_4_startDate ||
                      !this.state.report_4_endDate
                    }
                    onClick={this.applyDateFilter}
                  >
                    {t("find")}
                  </Button>
                  <Button onClick={this.clearDateFilter}>{t("clear")}</Button>
                </div>
              )}
              <Table
                bordered
                loading={loading}
                scroll={{ x: "max-content" }}
                columns={columns}
                dataSource={data}
                rowClassName={() => "govt-table-row"}
                pagination={{
                  ...pagination,
                  total: data.length,
                  showTotal: (total) => `Total ${total}`,
                }}
                onChange={this.handleTableChange}
                showSorterTooltip
              />
            </div>
          </div>
        </Spin>
        {this.state.imageOpen && (
          <ImageViewOnly
            imageOpen={this.state.imageOpen}
            imageUrl={CCTNS_MISSING_IMAGE_URL + this.state.selectedImage}
            downloadName={this.state.name}
            onClose={this.closeImageModal}
          />
        )}
        <Drawer
          title={
            <div>
              <div style={{ fontWeight: 600 }}>
                {t("list")}
                {selectedDistrict?.district_name
                  ? ` - ${selectedDistrict.district_name}`
                  : ""}
              </div>
              <div style={{ fontSize: 13, color: "#595959", marginTop: 4 }}>
                {t("total")}: {countDetails.length}
              </div>
            </div>
          }
          visible={showCountModal}
          onClose={this.closeCountDetailsModal}
          width={900}
          destroyOnClose
          footer={
            <div style={{ textAlign: "right" }}>
              <Button
                type="primary"
                disabled={!countDetails.length}
                onClick={() => this.downloadReport("modal")}
                style={{ marginRight: 8 }}
              >
                {t("download")}
              </Button>
              <Button onClick={this.closeCountDetailsModal}>
                {t("cancel")}
              </Button>
            </div>
          }
        >
          <Table
            bordered
            loading={countDetailsLoading}
            scroll={{ x: "max-content" }}
            columns={getListColumns(modalPagination, {
              controlled: true,
              order_by: this.state.modal_order_by,
              direction: this.state.modal_direction,
            })}
            dataSource={countDetails}
            rowKey={(record) => record.id}
            rowClassName={() => "govt-table-row"}
            pagination={{
              ...modalPagination,
              total: countDetails.length,
              showTotal: (total) => `Total ${total}`,
            }}
            onChange={this.handleModalTableChange}
            showSorterTooltip
          />
        </Drawer>
        <Drawer
          title={`${t("update")} - ${selectedMissing?.name || t("cctns_missing")}`}
          visible={showUpdateModal}
          onClose={this.closeUpdateModal}
          width={480}
          destroyOnClose
          footer={
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.closeUpdateModal}
                style={{ marginRight: 8 }}
              >
                {t("cancel")}
              </Button>
              <Button
                type="primary"
                loading={updateLoading}
                disabled={isAlreadyFound}
                onClick={this.submitMissingUpdate}
              >
                {t("update")}
              </Button>
            </div>
          }
        >
          <Form
            key={selectedMissing?.id || "missing-update"}
            ref={this.updateFormRef}
            layout="vertical"
            initialValues={{
              io_name: selectedMissing?.io_name || "",
              io_number: selectedMissing?.io_number || "",
              is_found: this.isMissingFound(selectedMissing?.is_found)
                ? "found"
                : "not_found",
              foundDate: selectedMissing?.foundDate
                ? moment(selectedMissing.foundDate)
                : null,
              date: selectedMissing?.date ? moment(selectedMissing.date) : "",
            }}
          >
            <Form.Item
              label={t("status")}
              name="is_found"
              rules={[
                { required: true, message: t("please_select_an_option") },
              ]}
            >
              <Radio.Group disabled={isAlreadyFound}>
                <Radio value="found">{t("found1")}</Radio>
                <Radio value="not_found">{t("are_misisng")}</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) => prev.is_found !== curr.is_found}
            >
              {({ getFieldValue }) =>
                getFieldValue("is_found") === "found" ? (
                  <Form.Item
                    label={t("found_date")}
                    name="foundDate"
                    rules={[{ required: true, message: t("select_date") }]}
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      style={{ width: "100%" }}
                      placeholder={t("select_date")}
                      disabled={isAlreadyFound}
                    />
                  </Form.Item>
                ) : (
                  <>
                    <Form.Item
                      label={t("date_of_missing")}
                      name="date"
                      rules={[{ required: true, message: t("select_date") }]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        placeholder={t("date_of_missing")}
                        disabled={true}
                      />
                    </Form.Item>
                  </>
                )
              }
            </Form.Item>
            <Form.Item
              label={t("investigating_officer1")}
              name="io_name"
              rules={[
                { required: true, message: t("please_select_an_option") },
              ]}
            >
              <Input
                placeholder={t("investigating_officer1")}
                disabled={isAlreadyFound}
              />
            </Form.Item>
            <Form.Item
              label={`${t("investigating_officer1")}(${t("mobile_number")})`}
              name="io_number"
              rules={[
                {
                  required: true,
                  message: "Please enter a valid 10-digit mobile number",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit mobile number",
                },
              ]}
            >
              <Input
                placeholder={t("mobile_number")}
                disabled={isAlreadyFound}
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  const pasted = event.clipboardData.getData("text");
                  if (!/^[0-9]+$/.test(pasted)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item label="ओरीजिनल फोटो (मोबाइल मधून काढलेला फोटो ) अपलोड करा">
              <Upload
                name="cctns-missing-persons"
                accept=".jpeg,.jpg,.png,.gif"
                listType="picture"
                maxCount={1}
                disabled={isAlreadyFound}
                fileList={originalFileList}
                beforeUpload={this.beforeOriginalFileUpload}
                customRequest={this.uploadOriginalImage}
                onChange={this.handleOriginalFileChange}
              >
                <Button icon={<UploadOutlined />} disabled={isAlreadyFound}>
                  {t("original_file")}
                </Button>
              </Upload>
            </Form.Item>
          </Form>
        </Drawer>
        <Drawer
          title={t("add_new")}
          visible={showAddModal}
          onClose={this.closeAddModal}
          width={520}
          destroyOnClose
          footer={
            <div style={{ textAlign: "right" }}>
              <Button onClick={this.closeAddModal} style={{ marginRight: 8 }}>
                {t("cancel")}
              </Button>
              <Button
                type="primary"
                loading={addLoading}
                onClick={this.submitMissingAdd}
              >
                {t("add_new")}
              </Button>
            </div>
          }
        >
          <Form
            ref={this.addFormRef}
            layout="vertical"
            initialValues={{
              is_found: "not_found",
              date: moment(),
              police_station: this.state.districtName || "",
              district: this.getCityName(user?.cityId) || "",
            }}
          >
            <Form.Item
              label={t("date_of_missing")}
              name="date"
              rules={[{ required: true, message: t("select_date") }]}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder={t("date_of_missing")}
              />
            </Form.Item>
            <Form.Item
              label="बेपत्ता इसम चे पूर्ण नाव"
              name="name"
              rules={[
                { required: true, message: t("please_select_an_option") },
              ]}
            >
              <Input placeholder={t("missing_people")} maxLength={200} />
            </Form.Item>
            <Form.Item
              label={t("accused_police_station")}
              name="police_station"
            >
              <Input disabled placeholder={t("accused_police_station")} />
            </Form.Item>
            <Form.Item label={t("district")} name="district">
              <Input disabled />
            </Form.Item>
            <Form.Item label={t("incident_place")} name="incident_place">
              <Input placeholder={t("incident_place")} maxLength={200} />
            </Form.Item>
            <Form.Item label={t("age")} name="age">
              <Input
                placeholder={t("age")}
                maxLength={3}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Form.Item label={t("gender")} name="gender">
              <Select placeholder={t("gender")} allowClear>
                <Option value="male">{t("male")}</Option>
                <Option value="female">{t("female")}</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label={t("status")}
              name="is_found"
              rules={[
                { required: true, message: t("please_select_an_option") },
              ]}
            >
              <Radio.Group>
                <Radio value="found">{t("found1")}</Radio>
                <Radio value="not_found">{t("are_misisng")}</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) => prev.is_found !== curr.is_found}
            >
              {({ getFieldValue }) =>
                getFieldValue("is_found") === "found" ? (
                  <Form.Item
                    label={t("found_date")}
                    name="foundDate"
                    rules={[{ required: true, message: t("select_date") }]}
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      style={{ width: "100%" }}
                      placeholder={t("select_date")}
                    />
                  </Form.Item>
                ) : null
              }
            </Form.Item>
            <Form.Item label={t("investigating_officer1")} name="io_name">
              <Input placeholder={t("investigating_officer1")} />
            </Form.Item>
            <Form.Item
              label={`${t("investigating_officer1")}(${t("mobile_number")})`}
              name="io_number"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || /^[0-9]{10}$/.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please enter a valid 10-digit mobile number"),
                    );
                  },
                },
              ]}
            >
              <Input
                placeholder={t("mobile_number")}
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  const pasted = event.clipboardData.getData("text");
                  if (!/^[0-9]+$/.test(pasted)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              label="ओरीजिनल फोटो (मोबाइल मधून काढलेला फोटो ) अपलोड करा"
              name="original_file"
              valuePropName="data-file-name"
              getValueFromEvent={(event) => {
                const fileList = Array.isArray(event)
                  ? event
                  : event?.fileList || [];
                if (!fileList.length) {
                  this.setState({
                    addOriginalFileList: [],
                    addOriginalImageName: null,
                  });
                  return undefined;
                }
                this.setState({
                  addOriginalFileList: fileList.slice(-1),
                });
                return this.state.addOriginalImageName || undefined;
              }}
              rules={[{ required: true, message: t("original_file") }]}
            >
              <Upload
                name="cctns-missing-persons"
                accept=".jpeg,.jpg,.png,.gif"
                listType="picture"
                maxCount={1}
                fileList={addOriginalFileList}
                beforeUpload={this.beforeOriginalFileUpload}
                customRequest={this.uploadAddImage}
              >
                <Button icon={<UploadOutlined />}>{t("original_file")}</Button>
              </Upload>
            </Form.Item>
          </Form>
        </Drawer>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connecteCcntsMissingReport = connect(mapStateToProps)(CcntsMissingReport);
export { connecteCcntsMissingReport as CcntsMissingReport };
